import React, { useContext } from 'react';
import LocaleContext from 'constants/localization';
import { isArchivedObjectFormat } from 'helpers/dataHelpers';

export default function CreateResourceButton({onCreate, label, disabled, objectFormat}) {
  const LS = useContext(LocaleContext);

  const action = getAction(LS, objectFormat);
  return (
    <button 
      type="button" 
      disabled={disabled} 
      onClick={onCreate}
      className="create-resource-button"
    >
      {action} {label}
    </button>
  );
}

const getAction = (LS, objectFormat) => {
  return isArchivedObjectFormat(objectFormat)
    ? LS.actions.addNew 
    : LS.actions.add;
};